import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './deals-list-item.component.scss';
var DealsListItem = /** @class */ (function (_super) {
    tslib_1.__extends(DealsListItem, _super);
    function DealsListItem(element) {
        return _super.call(this, element) || this;
    }
    DealsListItem.prototype.init = function () { };
    DealsListItem.prototype.bindEvents = function () { };
    return DealsListItem;
}(Base));
export { DealsListItem };



//////////////////
// WEBPACK FOOTER
// ./components/deals-list-item/deals-list-item.component.ts
// module id = 260
// module chunks = 0